const initialState = {
	_updateBoardChart: true,
	_updateBoardChartCompare: false,
	_chart: null,
	_chartToCompare: null,
	_componentInfoData: null,
	_componentInfoToCompareData: null,

	_selectedDataPointIndex: null, 
	_gapEventList: null,
};

const chartDataBoardReducer = (state = initialState, action) => {
	switch (action.type) {
		case "UPDATE_BOARD_EVENT":
			return {
				...state,
				_gapEventList: action.payload,
			};
		case "UPDATE_BOARD_CHART_SELECTED_DATAPOINT":
			return {
				...state,
				_selectedDataPointIndex: action.payload,
			};
		case "UPDATE_BOARD_CHART":
			return {
				...state,
				_updateBoardChart: action.payload.update,
				_chart: action.payload.chart,
			};
		case "UPDATE_BOARD_CHART_TO_COMPARE":
			return {
				...state,
				_updateBoardChartCompare: action.payload.update,
				_chartToCompare: action.payload.chart,
			};

		case "UPDATE_BOARD_COMPONENT_INFO":
			return {
				...state,
				_componentInfoData: action.payload.object,
				_updateBoardChart: action.payload.update,
			};
		case "UPDATE_BOARD_COMPONENT_INFO_TO_COMPARE":
			return {
				...state,
				_componentInfoToCompareData: action.payload.object,
				_updateBoardChartCompare: action.payload.update,
			};

		case "UPDATE_BOARD_COMPONENT_INFO_CHART_COMPARE":
			return {
				...state,
				_componentInfoToCompareData: action.payload.object,
				_chartToCompare: action.payload.chart,
				_updateBoardChartCompare: action.payload.update,
			};	
			
		default:
			return state;
	}
};

export default chartDataBoardReducer;